<script lang="ts">
  import { api, ApiError } from "../api";
  import { currentUser } from "../stores/auth";

  let { onClose }: { onClose: () => void } = $props();

  let currentPassword = $state("");
  let newPassword = $state("");
  let confirmPassword = $state("");
  let error = $state<string | null>(null);
  let success = $state(false);
  let submitting = $state(false);

  async function submit(event: SubmitEvent): Promise<void> {
    event.preventDefault();
    error = null;
    success = false;
    if (newPassword.length < 10) {
      error = "New password must be at least 10 characters";
      return;
    }
    if (newPassword !== confirmPassword) {
      error = "New passwords do not match";
      return;
    }
    submitting = true;
    try {
      await api.changePassword(currentPassword, newPassword);
      success = true;
      currentPassword = "";
      newPassword = "";
      confirmPassword = "";
    } catch (err) {
      error = err instanceof ApiError ? err.message : "Something went wrong";
    } finally {
      submitting = false;
    }
  }
</script>

<div class="page">
  <header>
    <button class="back" onclick={onClose} type="button" aria-label="Back">←</button>
    <h1>Account</h1>
  </header>

  <div class="content">
    <p class="username">Signed in as <strong>{$currentUser?.username}</strong></p>

    <form onsubmit={submit} class="card">
      <h2>Change password</h2>
      <label>
        Current password
        <input type="password" bind:value={currentPassword} autocomplete="current-password" required />
      </label>
      <label>
        New password
        <input type="password" bind:value={newPassword} autocomplete="new-password" minlength="10" required />
      </label>
      <label>
        Confirm new password
        <input type="password" bind:value={confirmPassword} autocomplete="new-password" minlength="10" required />
      </label>
      {#if error}
        <p class="error">{error}</p>
      {/if}
      {#if success}
        <p class="success">Password changed.</p>
      {/if}
      <button type="submit" disabled={submitting}>
        {submitting ? "Saving…" : "Change password"}
      </button>
    </form>
  </div>
</div>

<style>
  .page {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    padding-top: max(0.75rem, env(safe-area-inset-top));
    border-bottom: 1px solid var(--border);
  }
  .back {
    background: none;
    border: none;
    font-size: 1.3rem;
    cursor: pointer;
    color: var(--text);
  }
  h1 {
    margin: 0;
    font-size: 1.1rem;
  }
  .content {
    padding: 1rem;
    overflow-y: auto;
  }
  .username {
    color: var(--text-muted);
  }
  .card {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    max-width: 420px;
  }
  h2 {
    margin: 0 0 0.25rem;
    font-size: 1rem;
  }
  label {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    font-size: 0.9rem;
    color: var(--text-muted);
  }
  input {
    padding: 0.7rem;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    background: var(--bg);
    color: var(--text);
    font-size: 1rem;
  }
  button[type="submit"] {
    padding: 0.8rem;
    border: none;
    border-radius: var(--radius);
    background: var(--accent);
    color: var(--accent-contrast);
    font-weight: 600;
    cursor: pointer;
  }
  .error {
    color: var(--danger);
    margin: 0;
    font-size: 0.9rem;
  }
  .success {
    color: var(--accent);
    margin: 0;
    font-size: 0.9rem;
  }
</style>
